import { useCart } from "@/context/CartContext";

export const useStockInfo = (lookup_key) => {
  const { available } = useCart();
  const n = available(lookup_key);
  return { left: n, soldOut: n === 0, low: n > 0 && n <= 5 };
};

export const StockBadge = ({ lookup_key, className = "" }) => {
  const { left, soldOut, low } = useStockInfo(lookup_key);
  if (soldOut) return <span className={`inline-block font-cursive text-lg px-3 py-0.5 rounded-full bg-[#D1D5CB] text-[#4A3B32] ${className}`} data-testid={`stock-soldout-${lookup_key}`}>Épuisé ✿</span>;
  if (low) return <span className={`inline-block font-cursive text-lg px-3 py-0.5 rounded-full bg-[#FADADD] text-[#78353A] ${className}`} data-testid={`stock-low-${lookup_key}`}>Plus que {left} !</span>;
  return null;
};
